import React, { MouseEventHandler } from 'react'
import cx from 'classnames'
import { l } from '@manychat/manyui'

import './BlockButtonList.index.css'
import { IButton } from 'common/builder/buttons/buttonInterfaces'
import { SortableButton } from 'common/builder/components/builder/SortableButton'

import { EmptyTarget } from './EmptyTarget'

import styles from './BlockButtonList.module.css'

interface Props {
  builderId: string
  blockButtons: IButton[]
  allowAdd: boolean
  readonly: boolean
  onAdd: (button: { caption: string }) => void
  onMoveButton?: (dragButtonId: string, hoverButtonId: string) => void
  onMoveFirstButton?: (buttonId: string) => void

  lastRound: boolean
  mini: boolean // используется в LIST_ITEM
  buttonLabel?: string
  isFallback?: boolean
  tooltip?: string
  theme?: { selected: string }
  addBtnClassName?: string
  btnClassName?: string
  className?: string
  disabled?: boolean
  selected?: boolean
  btnRefClassName?: string
  newButtonCaption?: string
}

const BlockButtonList = ({
  builderId,
  blockButtons,
  allowAdd,
  readonly,
  onAdd,
  onMoveButton = () => {},
  onMoveFirstButton = () => {},
  lastRound,
  mini,
  buttonLabel,
  isFallback = false,
  tooltip = '',
  theme = { selected: '' },
  addBtnClassName,
  btnClassName,
  className,
  disabled = false,
  selected = false,
  btnRefClassName,
  newButtonCaption = 'New Button',
}: Props) => {
  const add: MouseEventHandler<HTMLDivElement> = (event) => {
    event.preventDefault()
    event.stopPropagation()
    if (disabled) {
      return
    }
    const caption = isFallback ? 'Fallback' : `${newButtonCaption} #${blockButtons.length + 1}`
    onAdd({ caption })
  }

  const isMultipleBlocks = blockButtons.length > 1
  const isEmpty = blockButtons.length === 0

  const addButtonClassName = cx('p-a-xs _cp bg-white text-center', styles.btnAdd, addBtnClassName, {
    [styles.btnAdd_border]: isEmpty,
    [styles.btnAdd_noborder]: isMultipleBlocks,
    [styles.mini]: mini,
    [styles.btnAddDisabled]: disabled,
  })
  const buttonClassName = cx(btnClassName, {
    [theme.selected]: selected,
  })
  const showTooltip = tooltip?.length

  return (
    <div className={cx('keyboard', styles.keyboardLastRound, className)}>
      {blockButtons.map((button, index) => {
        return (
          <SortableButton
            isFallback={isFallback}
            key={button.id}
            btnRefClassName={btnRefClassName}
            className={buttonClassName}
            builderId={builderId}
            buttonId={button.id}
            rounded={lastRound && !(allowAdd && !readonly) && index === blockButtons.length - 1}
            last={index === blockButtons.length - 1}
            first={index === 0}
            mini={mini}
            onMoveButton={onMoveButton}
            readonly={readonly}
          />
        )
      })}
      {allowAdd && !readonly && (
        <EmptyTarget disabled={Boolean(blockButtons.length)} onMove={onMoveFirstButton}>
          <div data-title={showTooltip ? tooltip : null} data-title-at="bottom">
            <div
              onClick={add}
              className={addButtonClassName}
              data-onboarding-id="text-block-add-button"
            >
              {buttonLabel ?? l.translate('+ Add Button')}
            </div>
          </div>
        </EmptyTarget>
      )}
    </div>
  )
}

export default BlockButtonList
